import * as Types from '../constants/actionTypes';

export default (state = {
  allAssetsType: [],
  assetsTypeList: []
}, action) => {
    // console.log(`state in auth is :`,state);
   switch (action.type) {
     case Types.SET_ALL_ASSETS: {
       return {
         ...state,
         allAssets: action.assetsData
       }
     }
    case Types.ASSETS_DETAIL_SUCCESS:
        return Object.assign({}, state, {assetsList : action.payload, isPending:false})    
       
    case Types.ASSETS_ADDED_SUCCESS:
        return Object.assign({}, state, {addStatus : action.payload, isPending:false})    
    case Types.ASSETS_DELETED_SUCCESS:
        return Object.assign({}, state, {deleteStatus : action.payload, isPending:false})    

    case Types.ASSETS_UPDATE_SUCCESS:
            return Object.assign({}, state, { updateStatus: action.payload})  
    case Types.ASSETS_TYPE_COUNT_SUCCESS:
            return Object.assign({}, state, { assetCount: action.payload})  
    case Types.SET_ALL_ASSETS_TYPE: {
      return {
        ...state,
        allAssetsType: action.allAssets
      }
    }        
    case Types.ASSETS_TYPE_DETAIL_SUCCESS:
      return {
        ...state,
        assetsTypeList:action.payload
      }
    case Types.ASSETS_TYPE_ADDED_SUCCESS:
      state.assetsTypeList.push(action.payload)
      return {
        ...state
      }
    case Types.ASSETS_TYPE_DELETED_SUCCESS:
      const newList = state.assetsTypeList.filter((assets) => assets.id !== action.payload )
      return {
        ...state,
        assetsTypeList : newList,
        deletedStatus:action.payload
      }
    case Types.ASSETS_TYPE_UPDATE_SUCCESS:
        const updateIndex = state.assetsTypeList.findIndex((oneAsset) => { return  oneAsset.id === action.payload.id} );
        if(updateIndex> -1) {
          state.assetsTypeList[updateIndex] = action.payload
        }
      return {
        ...state
      }    
    case Types.ASSETS_ERROR:
      return {
        ...state,
        assetError: action.assetError
      }
     default:
       return state;
   }
  };